//#region src/types/errors.ts
var DownloadError = class extends Error {
	payload;
	constructor(payload, message, cause) {
		super(message, { cause });
		this.name = "DownloadError";
		this.payload = payload;
	}
	get code() {
		return this.payload.code;
	}
};
function captureStackTrace(self, constructor) {
	if ("captureStackTrace" in Error && typeof Error.captureStackTrace === "function") Error.captureStackTrace(self, constructor);
}
var UserCanceled = class extends Error {
	skipped;
	constructor(skipped) {
		super("canceled by user");
		this.skipped = skipped ?? false;
	}
};
var DataInvalid = class extends Error {
	constructor(message) {
		super(message);
		this.name = this.constructor.name;
	}
};
var NotSupportedError = class NotSupportedError extends Error {
	constructor() {
		super("Not supported");
		captureStackTrace(this, NotSupportedError);
		this.name = this.constructor.name;
	}
};
var CleanupFailedException = class extends Error {
	mErrorObject;
	constructor(error) {
		super("Cleanup process has failed");
		this.name = this.constructor.name;
		this.mErrorObject = error;
	}
	get errorObject() {
		return this.mErrorObject;
	}
};
var ServiceTemporarilyUnavailable = class extends Error {
	constructor(service) {
		super(`${service} service is temporarily unavailable. Please try again later.`);
		this.name = this.constructor.name;
	}
};
var UnsupportedOperatingSystem = class extends Error {
	constructor() {
		super("Not supported on current Operating System");
		this.name = this.constructor.name;
	}
};
var InsufficientDiskSpace = class extends Error {
	constructor(mountPoint) {
		super(`The partition "${mountPoint}" has insufficient space.`);
		this.name = this.constructor.name;
	}
};
var ProcessCanceled = class extends Error {
	mExtraInfo;
	constructor(message, extraInfo) {
		super(message);
		this.name = this.constructor.name;
		this.mExtraInfo = extraInfo;
	}
	get extraInfo() {
		return this.mExtraInfo;
	}
};
var ArgumentInvalid = class extends Error {
	constructor(argument) {
		super(`Invalid argument: "${argument}"`);
		this.name = this.constructor.name;
	}
};
var MissingDependency = class extends Error {
	constructor() {
		super("Dependency is missing");
		this.name = this.constructor.name;
	}
};
var DocumentsPathMissing = class extends Error {
	constructor() {
		super("Failed to query the current user's documents folder");
		this.name = this.constructor.name;
	}
};
var SetupError = class extends Error {
	mComponent;
	constructor(message, component) {
		super(message);
		this.name = this.constructor.name;
		this.mComponent = component;
	}
	get component() {
		return this.mComponent;
	}
};
var TemporaryError = class extends Error {
	constructor(message) {
		super(message);
		this.name = this.constructor.name;
	}
};
var HTTPError = class extends Error {
	mCode;
	mMessage;
	mURL;
	constructor(statusCode, message, url) {
		super(`HTTP (${statusCode}) - ${message}`);
		this.name = this.constructor.name;
		this.mCode = statusCode;
		this.mMessage = message;
		this.mURL = url;
	}
	get statusCode() {
		return this.mCode;
	}
	get statusMessage() {
		return this.mMessage;
	}
	get url() {
		return this.mURL;
	}
};
var MissingInterpreter = class extends Error {
	mURL;
	constructor(message, url) {
		super(message);
		this.name = this.constructor.name;
		this.mURL = url;
	}
	get url() {
		return this.mURL;
	}
};
var NotFound = class extends Error {
	constructor(what) {
		super(`Not found: "${what}"`);
		this.name = this.constructor.name;
	}
};
var StalledError = class extends Error {
	constructor(msg) {
		super(msg);
		this.name = this.constructor.name;
	}
};
var TimeoutError = class extends Error {
	constructor() {
		super("Operation timed out");
		this.name = this.constructor.name;
	}
};
/**
* these errors we report but don't allow to be reported to us
*/
var ThirdPartyError = class extends Error {
	constructor(message) {
		super(message);
		this.name = this.constructor.name;
	}
};
var SelfCopyCheckError = class extends Error {
	constructor(src, dest, ino) {
		super(`Source "${src}" and destination "${dest}" are the same file (id "${ino}").`);
		this.name = this.constructor.name;
	}
};
var ArchiveBrokenError = class extends Error {
	mFileName;
	constructor(fileNameOrMessage, message) {
		if (message == null) {
			super(`Archive is broken: ${fileNameOrMessage}`);
			this.mFileName = void 0;
		} else {
			super(`Archive is broken: ${message}`);
			this.mFileName = fileNameOrMessage;
		}
		this.name = this.constructor.name;
	}
	get fileName() {
		return this.mFileName;
	}
};
var AlreadyDownloaded = class extends Error {
	mFileName;
	mId;
	constructor(fileName, id) {
		super("File already downloaded");
		Error.captureStackTrace(this, this.constructor);
		this.name = this.constructor.name;
		this.mFileName = fileName;
		this.mId = id;
	}
	get fileName() {
		return this.mFileName;
	}
	get downloadId() {
		return this.mId;
	}
	set downloadId(id) {
		this.mId = id;
	}
};
var DownloadIsHTML = class extends Error {
	mUrl;
	constructor(inputUrl) {
		super("");
		this.name = this.constructor.name;
		this.mUrl = inputUrl;
	}
	get url() {
		return this.mUrl;
	}
};

//#endregion
export { AlreadyDownloaded, ArchiveBrokenError, ArgumentInvalid, CleanupFailedException, DataInvalid, DocumentsPathMissing, DownloadError, DownloadIsHTML, HTTPError, InsufficientDiskSpace, MissingDependency, MissingInterpreter, NotFound, NotSupportedError, ProcessCanceled, SelfCopyCheckError, ServiceTemporarilyUnavailable, SetupError, StalledError, TemporaryError, ThirdPartyError, TimeoutError, UnsupportedOperatingSystem, UserCanceled };
//# sourceMappingURL=errors.js.map